module.exports = __webpack_public_path__ + "img/36_31.52b21cce.png";